import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { HeaderButtonBaseProps } from "@/components/Navigation/Buttons/HeaderButton/headerButton.base";

type CartButtonContextValue = {
    headerButtonProps: HeaderButtonBaseProps;
    redirect?: string;
    isUpdatingCart?: Record<string, boolean>;
    activeId: string;
    onRemoveFromCart?: (id: string, quantity: number, free: boolean) => void;
};

type CartButtonContextProviderProps = {
    headerButtonProps: HeaderButtonBaseProps;
    redirect?: string;
    isUpdatingCart?: Record<string, boolean>;
    activeId: string;
    onRemoveFromCart?: (id: string, quantity: number, free: boolean) => void;
    children: ReactNode;
};

export const CartButtonContext = createContext<
    CartButtonContextValue | undefined
>(undefined);

export const CartButtonContextProvider = ({
    headerButtonProps,
    redirect,
    isUpdatingCart,
    activeId,
    onRemoveFromCart,
    children
}: CartButtonContextProviderProps) => {
    return (
        <CartButtonContext
            value={{
                headerButtonProps: headerButtonProps,
                redirect: redirect,
                isUpdatingCart: isUpdatingCart,
                activeId: activeId,
                onRemoveFromCart: onRemoveFromCart
            }}
        >
            {children}
        </CartButtonContext>
    );
};

export const useCartButtonContext = () => {
    const context = use<CartButtonContextValue | undefined>(CartButtonContext);

    if (!isDefined(context)) {
        throw new Error(`${CartButtonContext.displayName} is undefined.`);
    }

    return context;
};
